import { Reveal, SectionHead } from "./Reveal";

const defects = [
  ["01", "Moisture indications & leakage", "Visible damp or staining around wet areas, ceilings and plumbing."],
  ["02", "Sealant, grout & wet-area finishing", "Gaps and workmanship issues in sealing and grouting."],
  ["03", "Cracked, hollow or damaged tiles", "Hairline, drummy and surface defects across floors and walls."],
  ["04", "Cooling & airflow observations", "Airflow and cooling inconsistencies across zones."],
  ["05", "Misaligned doors, windows & joinery", "Alignment and closing defects in joinery."],
  ["06", "Damaged cabinetry & finishes", "Finish, fit and installation concerns."],
  ["07", "Visible electrical fitting concerns", "Faulty sockets, switches and installation issues."],
  ["08", "Uneven surfaces & incomplete work", "Surface, paint and levelling deficiencies."],
];

export default function ExampleFindings() {
  return (
    <section className="py-20 lg:py-24 bg-soft border-y border-line" data-testid="example-findings">
      <div className="wrap">
        <SectionHead eyebrow="Example inspection findings" title="New does not always mean defect-free."
          sub="Typical findings from real inspection categories. Inspections are visual and non-destructive — findings are limited to areas that are safe, accessible and observable on the inspection date." />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {defects.map(([n, t, d], i) => (
            <Reveal key={n} delay={(i % 4) * 0.05}>
              <div className="group bg-white border border-line rounded-[14px] p-5 h-full hover:border-blue hover:shadow-md hover:-translate-y-0.5 transition-all">
                <div className="font-mono-jb text-[0.68rem] text-blue tracking-wider">{n}</div>
                <h3 className="text-[0.98rem] font-semibold mt-2 mb-1">{t}</h3>
                <p className="text-[0.82rem] text-muted leading-snug">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
